import React, { Component } from "react";

import { withFormik } from "formik";

import * as Yup from "yup";
import styled from "styled-components";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import ListAltIcon from "@material-ui/icons/ListAlt";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Button from "@material-ui/core/Button";

import { DayPlan } from "../../../../../types/DayPlan";
import {
  Wrapper,
  getRowItemObject,
  renderRowWInputNCheckbox,
  renderRowWithTwoItems,
} from "../../../../common/FormUtils";
import Table from "../../../../common/table";
import { Author } from "../../../../../types/Author";
import { stepTabConfig } from "../../config/tabConfig";
import FullScreenDialog from "../../../../common/FullScreenDialog";
import DailyStepForm from "./dailyStep/DailyStepForm";
import createDailyStep from "../../../../../database/dailyStep/createDailyStep";
import { getFirebaseKey } from "../../../../../database/utils/getFirebaseKey";
import { DAILY_STEP_TYPE, DailyStep } from "../../../../../types/DailyStep";
import ActionFormButton from "../../../../common/ActionFormButton";
import { firestore } from "../../../../../database/firebase";
import DB_PATH from "../../../../../database/DB_PATH";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px;
`;

const SectionCard = styled(Paper)`
  padding: 24px;
  border-radius: 12px;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

const SectionTitle = styled(Typography)`
  font-weight: 600;
  color: #1a1a2e;
`;

const SectionSubtitle = styled(Typography)`
  color: #6b7280;
  margin-top: 4px;
`;

const StepsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const AddStepButton = styled(Button)`
  text-transform: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 500;
`;

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 2px dashed #e5e7eb;
`;

const EmptyStateText = styled(Typography)`
  color: #6b7280;
  margin-top: 12px;
`;

const TableContainer = styled.div`
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;

type Props = {
  onChageFormToEditMode: Function;
  onToggleFullScreenDialog;
  setFieldValue: Function;
  handleSubmit: any;
  onRemoveItem: Function;
  brands: Array<any>;
  values: any;
  errors: Object;
  onEditItem: any;
  isSubmitting: boolean;
  mode: string;
  item: DayPlan;
  authors: Author[];
  authorID: string;
  communityId: string;
  planID?: string;
  planTitle?: string;
  planDescription?: string;
  authorName?: string;
  authorDescription?: string;
  steps?: DailyStep[];
};

type State = {
  isSaleConfirmationDialogOpen: boolean;
  shouldBlockFormSubmit: boolean;
  isStepFormDialogVisible: boolean;
  stepSelected: DailyStep;
  mode: string;
};

class SubDailyStepForm extends Component<Props, State> {
  //@ts-ignore
  state = {
    isSaleConfirmationDialogOpen: false,
    shouldBlockFormSubmit: false,
    isStepFormDialogVisible: false,
    stepSelected: {
      id: "",
      title: "",
      subtitle: "",
      description: "",
      text: "",
      quote: "",
      communityId: "",
      reference: "",
      authorID: "",
      type: DAILY_STEP_TYPE.DEFAULT,
      dayPlanID: "",
      planID: "",
    },
    mode: "",
  };

  handleBlockFormSubmit = (value: boolean): void => {
    this.setState({
      shouldBlockFormSubmit: value,
    });
  };

  renderIndexName = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Title of the day plan",
      "Type the title of the day plan",
      "string",
      "title"
    );
    const indexInputField = getRowItemObject(
      "Position",
      "Which is the index of this day plan?",
      "string",
      "position"
    );

    return renderRowWithTwoItems(
      salePriceInputFieldData,
      indexInputField,
      this.props
    );
  };
  renderDescriptions = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Descriptions of the day plan",
      "Type the description of the day plan",
      "textarea",
      "description"
    );
    const isSaleActiveInputFieldData = getRowItemObject(
      "Posición",
      "Type the short description of the day plan",
      "string",
      "shortDescription"
    );

    return renderRowWithTwoItems(
      salePriceInputFieldData,
      isSaleActiveInputFieldData,
      this.props
    );
  };

  renderFreeDailySteps = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Description",
      "Type the description of the day plan",
      "textarea",
      "description"
    );
    const isRequiredInputFieldData = getRowItemObject(
      "Is this plan Active?",
      "",
      "checkbox",
      "isActive"
    );
    return renderRowWInputNCheckbox(
      salePriceInputFieldData,
      isRequiredInputFieldData,
      this.props
    );
  };

  renderDayPlan = (): Object => {
    return (
      <SectionCard elevation={1}>
        <SectionHeader>
          <InfoOutlinedIcon style={{ color: "#6366f1" }} />
          <div>
            <SectionTitle variant="h6">Day Plan Details</SectionTitle>
            <SectionSubtitle variant="body2">
              Configure the basic information for this day plan
            </SectionSubtitle>
          </div>
        </SectionHeader>
        {this.renderIndexName()}
        {this.renderFreeDailySteps()}
      </SectionCard>
    );
  };

  onAddStep = (step: DailyStep) => {
    const prevDailySteps: DailyStep[] = this.props.values["steps"] || [];
    this.props.setFieldValue("steps", [...prevDailySteps, step]);
  };
  onToggleStepForm = (): void => {
    this.setState({
      isStepFormDialogVisible: !this.state.isStepFormDialogVisible,
    });
  };

  onAddAuthor = ({ id, fullName }: Author) => {
    const prevDailySteps: Author[] = this.props.values["authors"] || [];
    this.props.setFieldValue("itemsIds", [
      ...prevDailySteps,
      {
        id,
        fullName,
        description: "",
        coverURL: "",
        createdAt: Date.now(),
        profilePhotoURL: "",
        shortDescription: "",
        communityId: "",
        tags: [],
      },
    ]);
  };
  onRemoveStep = (subsection: DayPlan) => {
    const prevDailySteps = this.props.values["itemsIds"] || [];

    const newDailySteps = prevDailySteps.filter((_DailyStep) => _DailyStep.id !== subsection.id);
    this.props.setFieldValue("itemsIds", [...newDailySteps]);
  };
  onEditIconClicked = (stepSelected: DailyStep): void => {
    console.log("StepSelected12", stepSelected);
    this.setState({
      isStepFormDialogVisible: true,
      mode: "edit",
      stepSelected,
    });
  };
  onAddIconClicked = (): void => {
    this.setState({
      isStepFormDialogVisible: true,
      mode: "create",
      stepSelected: null,
    });
  };

  onRemoveDailyStep = async (dailyStep: DailyStep) => {
    const { id, title } = dailyStep;
    // Ask for confirmation (no-op on SSR)
    const confirmed =
      typeof window === "undefined"
        ? true
        : window.confirm(
          `Delete this step${title ? `: "${title}"` : ""
          }? This action cannot be undone.`
        );

    if (!confirmed) {
      console.log("Deletion cancelled by user");
      return { confirmed: false, deleted: false as const };
    }

    try {
      // If your DB_PATH uses a different key (e.g., DB_PATH.STEPS or DB_PATH.step),
      // change DB_PATH.STEP accordingly.
      await firestore.collection(DB_PATH.PLAN_STEP).doc(id).delete();

      const prevDailySteps: DailyStep[] = this.props.values["steps"];
      const newDailySteps = Object.values(prevDailySteps).filter(
        (_dailyStep) => _dailyStep?.id !== id
      );
      this.props.setFieldValue("steps", newDailySteps);
      console.log(`Document with stepID: ${id} successfully deleted`);
      return { confirmed: true, deleted: true as const };
    } catch (error) {
      console.error("Error removing step document: ", error);
      return { confirmed: true, deleted: false as const, error };
    }
  };

  renderSubDailySteps = ({
    mode,
  }: any): Object => {
    const { handleSubmit } = this.props;
    const steps = Object.values(this.props.values.steps || []);
    const hasSteps = steps.length > 0;

    return (
      <SectionCard elevation={1}>
        <StepsHeader>
          <SectionHeader style={{ marginBottom: 0 }}>
            <ListAltIcon style={{ color: "#6366f1" }} />
            <div>
              <SectionTitle variant="h6">Daily Steps</SectionTitle>
              <SectionSubtitle variant="body2">
                {hasSteps
                  ? `${steps.length} step${steps.length !== 1 ? "s" : ""} configured`
                  : "Add steps to guide users through this day"}
              </SectionSubtitle>
            </div>
          </SectionHeader>
          <AddStepButton
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={this.onAddIconClicked}
          >
            Add Step
          </AddStepButton>
        </StepsHeader>

        {hasSteps ? (
          <TableContainer>
            <Table
              currentPage={0}
              updatePageIndex={() => {}}
              onEditIconClicked={this.onEditIconClicked}
              onRemoveIconClicked={(DailyStep) => this.onRemoveDailyStep(DailyStep)}
              tabConfig={stepTabConfig}
              dataset={steps}
              canBeRemoved
              canBeEdited
            />
          </TableContainer>
        ) : (
          <EmptyStateContainer>
            <ListAltIcon style={{ fontSize: 48, color: "#d1d5db" }} />
            <EmptyStateText variant="body1">
              No steps added yet
            </EmptyStateText>
            <EmptyStateText variant="body2">
              Click "Add Step" to create your first daily step
            </EmptyStateText>
          </EmptyStateContainer>
        )}

        <ActionFormButton
          onClick={handleSubmit}
          disabled={false}
          entity="Plan"
          canBeRemoved
          mode={mode}
        />
      </SectionCard>
    );
  };

  onCreateDailyStep = (dailyStep: DailyStep) => {
    const id = getFirebaseKey();
    const planID =
      dailyStep.planID ||
      this.props.values.planID ||
      this.props.item?.planID;
    const dayPlanID =
      dailyStep.dayPlanID || this.props.values.id || this.props.item?.id;

    const enrichedDailyStep = {
      ...dailyStep,
      id,
      planID,
      dayPlanID,
    };

    createDailyStep({ dailyStep: enrichedDailyStep });

    this.props.setFieldValue("steps", [
      ...Object.values(this.props.values.steps),
      enrichedDailyStep,
    ]);
    this.onToggleStepForm();
  };
  onEditDailyStep = (step) => {
    const newSteps = (this.props.values.steps || []).map((currentStep) =>
      currentStep?.id === this.state.stepSelected?.id ? step : currentStep
    );
    this.props.setFieldValue("steps", newSteps);
    this.onToggleStepForm();
  };
  renderDailyStepForm = (): any => {
    return (
      <FullScreenDialog
        onClose={this.onToggleStepForm}
        isOpen={this.state.isStepFormDialogVisible}
        title={"Step"}
      >
        <DailyStepForm
          onToggleFullScreenDialog={this.onToggleStepForm}
          item={this.state.stepSelected}
          mode={this.state.mode}
          planID={this.props.item?.planID}
          dayPlanID={this.props.item?.id}
          communityId={this.props.communityId}
          onCreateItem={this.onCreateDailyStep}
          onEditItem={this.onEditDailyStep}
          onRemoveItem={this.onRemoveDailyStep}
          authorID={this.props.authorID}
          planTitle={this.props.planTitle}
          planDescription={this.props.planDescription}
          dayPlanTitle={this.props.item?.title || ""}
          dayPlanDescription={this.props.item?.description || ""}
          authorName={this.props.authorName}
          authorDescription={this.props.authorDescription}
          steps={this.props.values.steps}
        ></DailyStepForm>
      </FullScreenDialog>
    );
  };
  render() {
    return (
      <Wrapper>
        <FormContainer>
          {this.renderDayPlan()}
          {this.renderSubDailySteps(this.props)}
        </FormContainer>
        {this.renderDailyStepForm()}
      </Wrapper>
    );
  }
}

const CustomForm = withFormik({
  mapPropsToValues: (props: any): DayPlan => {
    const { item, storeId, mode } = props;
    return {
      isActive: item.isActive || false,
      steps: [...(item.steps || [])],
      id: item.id || "",
      position: item.position || 0,
      title: item.title || "",
      createdAt: item.createdAt || Date.now(),
      description: item.description || "",
      planID: item.planID || props.planID,
      authorID: item.authorID || props.authorID,
      communityId: item.communityId || props.communityId,
    };
  },

  validationSchema: ({ item, mode }) =>
    Yup.lazy((values) =>
      Yup.object().shape({
        title: Yup.string().required("The title is required."),
      })
    ),

  handleSubmit(values, { setSubmitting, props }) {
    const { onCreateItem, onEditItem, mode } = props;

    const properCallback = mode === "edit" ? onEditItem : onCreateItem;

    console.log("Saving DayPlan", mode);
    properCallback({
      ...values,
    });

    setSubmitting(false);
  },
  enableReinitialize: true,
})(SubDailyStepForm);

export default CustomForm;
